import { initializeCalendarsCacheInStore } from 'owa-calendar-cache';
import { getCalendarsService } from '../services/getCalendarsService';
import { convertToCalendarCacheStoreData } from './convertToCalendarCacheStoreData';
import { trace } from 'owa-trace';

export async function initializeOutlookAccountCalendarsInCache(userId: string): Promise<void> {
    const response = await getCalendarsService(userId);
    if (response !== null && response.WasSuccessful) {
        const cacheData = convertToCalendarCacheStoreData(
            response.CalendarGroups,
            response.CalendarFolders,
            userId
        );
        initializeCalendarsCacheInStore(
            cacheData.defaultCalendar,
            cacheData.calendarEntryMapping,
            cacheData.calendarFolderMapping,
            cacheData.calendarGroupMapping,
            cacheData.folderIdMapping,
            cacheData.calendarIdToChangeKeyMapping
        );
    } else {
        trace.error('[getCalendarFoldersFromServer] Failed to load calendars from server');
    }
}
